import {
    useState,
    useEffect
} from 'react';
import {
    Container,
} from './styled';
import {
    FaBookmark,
    FaRegBookmark
} from "react-icons/fa";
import {
    CheckBox
} from '../../../components';
export function GroupsAction(props) {

    const { group, onChange, initialValue } = props;
    const [linked, setLinked] = useState(initialValue)


    useEffect(() => {
        setLinked(initialValue)
    }, [initialValue])

    return (
        <Container>
            <div className='prev--'>
                {(linked)
                    ? (<FaBookmark color='#1D86FF' />)
                    : (<FaRegBookmark />)
                }
                <span>
                    {group?.nomecompleto}
                </span>
            </div>
            <div>
                <CheckBox
                    onChange={onChange}
                    initialValue={linked}
                />
            </div>
        </Container>
    )
}